import Vue from 'vue'
import {
  PRODUCT_SELECTION_ERROR_TYPES,
  ProductEstimate,
  ProductSku,
  ProductState,
  SkuSize
} from '@/product/types'
import { limitMaxQuantityInputError, sizeInputError } from '@/common/utils/common'

export default Vue.extend({
  data(): {
    sizes: SkuSize[]
    errors: string[]
    updateSizeQuantityDebounce: (() => void) | undefined
  } {
    return {
      sizes: [],
      errors: [],
      updateSizeQuantityDebounce: undefined
    }
  },
  computed: {
    $_storeState(): ProductState {
      return this.$store.state
    },
    $_productSku(): ProductSku {
      return this.$_storeState.productDetail.sku
    },
    $_skuSizes(): SkuSize[] {
      return this.$store.getters.skuSizes
    },
    $_currentSku(): string {
      return this.$_productSku.id
    },
    $_currentColorPatternName(): string {
      return this.$_estimate.selectedColorPattern.colorPattern.displayName
    },
    $_estimate(): ProductEstimate {
      return (this.$_storeState as ProductState).estimate
    },
    $_quantityUnit(): string {
      return this.$_estimate.quantityUnit
    },
    $_outOfStockSizeMessage(): string {
      const outStockSizes = this.sizes.filter(size => !size.hasStock)
      return outStockSizes.length > 0 ? `在庫切れ：${outStockSizes.map(size => size.name).join(', ')}サイズ` : ''
    },
    $_totalQuantity(): number {
      return this.sizes.reduce((sum: number, item) => sum+= (item.quantity || 0), 0)
    },
    $_maxTotalQuantity(): number {
      return this.$_storeState.maxQuantity
    },
    $_validQuantity(): boolean {
      return this.$_storeState.validQuantity
    }
  },
  watch: {
    $_currentSku(newVal: string | number, oldVal: string | number) {
      if (newVal != oldVal) this.$_onUpdateSkuSizes()
    },
    $_maxTotalQuantity() {
      this.$_validateTotalQuantity()
    }
  },
  mounted() {
    this.errors = []
    const initSizeQuantity = this.$_estimate.sizeItems?.reduce((obj: {[key: number]: number}, item) => Object.assign(obj, { [item.sizeId]: item.quantity}), {})
    this.sizes = this.$_skuSizes.map(item => {
      return Object.assign({}, item, {
        quantity: initSizeQuantity[item.id] || 0
      })
    })
    this.$_validateTotalQuantity()
  },
  methods: {
    $_onUpdateSkuSizes() {
      this.errors = []
      const estimateSizeItems = this.$_estimate.sizeItems
      const inputMap: {[key: number]: number} = estimateSizeItems.reduce((obj, item) => {
        return Object.assign(obj, {
          [item.sizeId]: item.quantity
        })
      }, {})
      this.sizes = this.$_skuSizes.map((item: SkuSize) => {
        return Object.assign({}, item, {
          quantity: inputMap[Number(item.id)] || 0
        })
      })
      this.$_commitInputSize()
      this.$_validateTotalQuantity()
    },
    $_onChangeSizeInput() {
      this.$_commitInputSize()
      this.$emit('onChangeSizeInput')

      this.$store.commit(
        'solveSelectErrorItem',
        PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SIZE
      )
    },
    $_commitInputSize() {
      const input = this.sizes.map(item => {
        return {
          id: item.id,
          quantity: item.quantity || 0
        }
      })
      this.$store.commit('setSizeInput', input)
    },
    $_validateTotalQuantity() {
      this.errors = []
      this.$store.commit('setValidQuantity', true)
      const invalidItems = this.sizes.filter((item: SkuSize) => item.quantity && item.quantity > item.maxQuantity)
      this.errors = invalidItems.map(item => sizeInputError(item.name, item.maxQuantity, this.$_quantityUnit))
      if (this.$_maxTotalQuantity > -1 && this.$_totalQuantity > this.$_maxTotalQuantity) {
        this.errors.push(limitMaxQuantityInputError(this.$_currentColorPatternName, this.$_maxTotalQuantity))
      }
      if (this.errors.length > 0) {
        this.$store.commit('setValidQuantity', false)
      }
    }
  }
})
